<div
  [matTooltip]="itemName"
  matTooltipClass="lnr-mat-tooltip"
  [matTooltipPosition]="'after'"
  [ngClass]="{
    'lnr-sidemenu-item': isMobile,
    'lnr-sidemenu-item-desktop': !isMobile,
    'expand-row': expandRow,
    active: isActive
  }"
>
  <nb-icon class="icon" icon="{{ icon }}"></nb-icon>
  <span class="text">
    <ng-content></ng-content>
  </span>
</div>
